import _ownerDocument from './ownerDocument';
export { _ownerDocument as ownerDocument };
import _ownerWindow from './ownerWindow';
export { _ownerWindow as ownerWindow };
import _getWindow from './getWindow';
export { _getWindow as getWindow };
import _getContainer from './getContainer';
export { _getContainer as getContainer };
import _canUseDOM from './canUseDOM';
export { _canUseDOM as canUseDOM };
import _contains from './contains';
export { _contains as contains };
import _scrollTop from './scrollTop';
export { _scrollTop as scrollTop };
import _scrollLeft from './scrollLeft';
export { _scrollLeft as scrollLeft };
import _getOffset from './getOffset';
export { _getOffset as getOffset };
import _nodeName from './nodeName';
export { _nodeName as nodeName };
import _getOffsetParent from './getOffsetParent';
export { _getOffsetParent as getOffsetParent };
import _getPosition from './getPosition';
export { _getPosition as getPosition };
import _isOverflowing from './isOverflowing';
export { _isOverflowing as isOverflowing };
import _activeElement from './activeElement';
export { _activeElement as activeElement };
import _getScrollbarSize from './getScrollbarSize';
export { _getScrollbarSize as getScrollbarSize };
import _getHeight from './getHeight';
export { _getHeight as getHeight };
import _getWidth from './getWidth';
export { _getWidth as getWidth };


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/query/index.js
// module id = 745
// module chunks = 31